<template>
    <BlocoAccordion
        titulo="Produção"
        tema="producao"
        subtitulo="1 indicador"
        descricao="Média diária de produtos acabados por família"
    >
        <ProduçãoDiaria @updateMes="atualizarMes" :mes="mes" :ano="ano" />
    </BlocoAccordion>
</template>

<script>
import BlocoAccordion from './BlocoAccordion.vue';
import ProduçãoDiaria from './Graficos/Produção/ProduçãoDiaria.vue';

export default {
    name: 'BlocoProdução',
    components: {
        BlocoAccordion,
        ProduçãoDiaria,
    },
    props: {
        mes: { required: true },
        ano: { required: true },
    },
    emits: ['updateMes'],
    methods: {
        atualizarMes(mes) {
            this.$emit('updateMes', mes);
        },
    },
};
</script>
